/**
 * Custom event system for handling authentication state changes
 * This allows API layer to communicate with React components without direct imports
 */

import { AUTH_EVENTS } from './constants';

/**
 * Emit an authentication event
 * @param {string} eventName - Event name from AUTH_EVENTS
 * @param {Object} detail - Optional event detail data
 */
export const emitAuthEvent = (eventName, detail = {}) => {
  const event = new CustomEvent(eventName, { detail });
  window.dispatchEvent(event);
};

/**
 * Listen for authentication events
 * @param {string} eventName - Event name from AUTH_EVENTS
 * @param {Function} handler - Event handler function
 * @returns {Function} Cleanup function to remove listener
 */
export const onAuthEvent = (eventName, handler) => {
  const listener = (event) => handler(event.detail);
  window.addEventListener(eventName, listener);
  return () => window.removeEventListener(eventName, listener);
};

/**
 * Emit unauthorized event (401 error)
 */
export const emitUnauthorized = () => {
  emitAuthEvent(AUTH_EVENTS.UNAUTHORIZED);
};

/**
 * Emit token expired event
 */
export const emitTokenExpired = () => {
  emitAuthEvent(AUTH_EVENTS.TOKEN_EXPIRED);
};

/**
 * Emit logout event
 */
export const emitLogout = () => {
  emitAuthEvent(AUTH_EVENTS.LOGOUT);
};
